<template>
  <v-select
    :label="label == null ? $t('keywords.authentication.ws_type') : label"
    :items="wsAuthenticationTypes"
    v-bind="{...$attrs, ...$props}"
    v-on="$listeners"
  />
</template>
<script>

export default {
  name: 'AuthenticationSelect',

  props: {
    label: String
  },

  computed: {
    wsAuthenticationTypes () {
      return [
        {
          text: this.$t('keywords.none'),
          value: 'Nenhum'
        },
        {
          text: 'Bearer',
          value: 'Bearer'
        },
        {
          text: 'Basic',
          value: 'Basic'
        }
      ]
    }
  }
}
</script>
